import { Base } from "./base";

export class PortalOperatorLocation extends Base {
    PortalOperatorLocationID?: string;
    PortalOperatorID?: string;
    Date?: Date;
    Latitude?: number;
    Longitude?: number;

    //#region Web properties
    VehicleCheckID?: string;
    Icon?: string;
    IsSelected?: boolean = false;
    FineID?: string;
    //#endregion
}